import type { RootState } from '../store';
export const selectAdminUser = (state: RootState) => state.adminUser;
